import { fetchRooms,getPricesFromStorage, savePricesToStorage} from '../model/room-load.js';


const FETCH_PRICES_ERROR = 'PriceLoad load error:';

export class PriceLoad {
    constructor() {
        this._cachePrices = getPricesFromStorage();
    }

    isLoadNeeded() {
        return !this._cachePrices;
    }

    load() {
        return fetchRooms()
            .then((prices) => {
                savePricesToStorage(JSON.stringify(prices));
                return prices;
            })
            .catch((error) => {
                console.log(FETCH_PRICES_ERROR);
                console.log(error);
            });
    }

    getFromCache() {
        console.log(this._cachePrices)
        return JSON.parse(this._cachePrices);
    }
}
